import React, {useRef, useEffect, useState, ReactNode} from 'react';
import {motion} from 'motion/react';
import bg from '../../assets/notice-bar.webp';
import {ReactComponent as Icon} from '../../assets/notice-bar-icon.svg';

interface NoticeBarProps {
  text?: ReactNode;
}

export default function NoticeBar({text = ''}: NoticeBarProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const measureText = () => {
      if (textRef.current && containerRef.current) {
        const textElement = textRef.current;
        const containerElement = containerRef.current;

        setTextWidth(textElement.scrollWidth);
        setShouldScroll(textElement.scrollWidth > containerElement.clientWidth);
      }
    };

    measureText();

    // 监听窗口大小变化
    window.addEventListener('resize', measureText);

    return () => {
      window.removeEventListener('resize', measureText);
    };
  }, [text]); // 添加text依赖，当text改变时重新测量

  return (
    <div
      className="w-full bg-full h-7 pl-[4.0625rem] pr-12 mt-3.5 z-100 relative"
      style={{
        backgroundImage: `url(${bg})`,
      }}>
      <div className="flex gap-1 h-full items-center">
        <Icon className="size-[0.9375rem] flex-shrink-0"></Icon>
        <div
          className="flex-1 overflow-hidden flex h-full relative items-center"
          ref={containerRef}>
          {shouldScroll ? (
            <motion.div
              className="flex"
              animate={{
                x: [0, -textWidth - 20], // 20px为间隔
              }}
              transition={{
                duration: Math.max(8, textWidth / 30), // 根据文字长度调整速度
                repeat: Infinity,
                ease: 'linear',
                delay: 1, // 开始前延迟1秒
              }}>
              <div
                ref={textRef}
                className="whitespace-nowrap text-[0.625rem] font-medium capitalize leading-normal pr-5"
                style={{
                  color: '#FFEAA7',
                  textShadow: `
                    -1px -1px 0 #644100,
                    1px -1px 0 #644100,
                    -1px 1px 0 #644100,
                    1px 1px 0 #644100
                  `,
                }}>
                {text}
              </div>
              {/* 复制一份文字用于无缝循环 */}
              <div
                className="whitespace-nowrap text-[0.625rem] font-medium capitalize leading-normal"
                style={{
                  color: '#FFEAA7',
                  textShadow: `
                    -1px -1px 0 #644100,
                    1px -1px 0 #644100,
                    -1px 1px 0 #644100,
                    1px 1px 0 #644100
                  `,
                }}>
                {text}
              </div>
            </motion.div>
          ) : (
            <div
              ref={textRef}
              className="whitespace-nowrap text-[0.625rem] font-medium capitalize leading-normal"
              style={{
                color: '#FFEAA7',
                textShadow: `
                  -1px -1px 0 #644100,
                  1px -1px 0 #644100,
                  -1px 1px 0 #644100,
                  1px 1px 0 #644100
                `,
              }}>
              {text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
